// Contact details and links reused across pages.
const site = {
  email: 'johnnykim94@hotmail.com',
  resumeUrl:
    'https://drive.google.com/file/d/14O3aiGcORyFhJNDx9i9IJApwfczz46I7/view?usp=sharing',
  github: 'https://github.com/bellhwi',
}

export { site }
